import classes from '../index.module.scss';
import { AppImage } from '../../../../../../../ui/AppImage';
import { InfoIconComponent } from '../../../pages/PreviewPage/components/InfoIconComponent';

export function Picture({ cell }) {
  return (
    <div className={classes.picture}>
      <AppImage src={cell?.image} alt='Picture' />
      {cell?.infoIcon && <InfoIconComponent type={cell} />}
    </div>
  );
}
